module.exports = __webpack_public_path__ + "static/media/familia-vinicius.34d499c8.webp";